export { Image } from '@theme-ui/components';
export type { ImageProps } from '@theme-ui/components';
